import React from 'react'
import { VelocityTransitionGroup } from 'velocity-react'
import bemCx from 'bem-modifiers'
import { debounce } from 'lodash'

import { hasWindow } from '~/utils/helpers'

class FaqItem extends React.Component {
  state = {
    openIndex: null,
    copied: false
  }

  componentDidMount () {
    if (this.props.openQuestionIndex) {
      this.setState({
        openIndex: {
          query: this.props.openQuestionIndex.queryId,
          category: this.props.openQuestionIndex.categoryId
        }
      })
    }
  }

  handleToggle = debounce((queryId, categoryId) => {
    this.setState(prevState => ({
      openIndex: {
        query: prevState.openIndex && prevState.openIndex.query === queryId ? null : queryId,
        category: categoryId
      }
    }))
  }, 100)

  handleCopy = e => {
    const { queryId, categoryId } = this.props
    e.stopPropagation()
    if (hasWindow() && navigator.clipboard) {
      const origin = window.location.origin
      navigator.clipboard.writeText(`${origin}/faq#${categoryId}-${queryId}`)
        .then(() => this.setState({ copied: true }))
    }
  }

  render () {
    const { question, answer, queryId, categoryId, t } = this.props
    const { openIndex, copied } = this.state

    const isOpen = openIndex && openIndex.query === queryId && openIndex.category === categoryId

    return (
      <div
        className='faq-item'
        onClick={() => this.handleToggle(queryId, categoryId)}
        id={`${categoryId}-${queryId}`}
      >
        <div className='faq-item__question'>
          <span className={bemCx('faq-item__icon', { 'open': isOpen }, isOpen ? 'i-minus' : 'i-plus')} />
          <h4
            className='faq-item__question-text'
            dangerouslySetInnerHTML={{ __html: question }}
          />
          <span
            className='faq-item__copy i-link'
            onClick={this.handleCopy}
          />
          <div
            className={bemCx('faq-item__copy-message', { 'open': copied })}
            onAnimationEnd={() => this.setState({ copied: false })}
          >
            {t('common:copied_massage')}
          </div>
        </div>
        <VelocityTransitionGroup
          className={bemCx('faq-item__answers', { 'visible': isOpen })}
          enter={{ animation: 'slideDown' }}
          leave={{ animation: 'slideUp' }}
        >
          {isOpen && answer && answer.map((paragraph, paragraphId) =>
            <p
              key={paragraphId}
              className='faq-item__paragraph'
              dangerouslySetInnerHTML={{ __html: paragraph }}
            />
          )}
        </VelocityTransitionGroup>
      </div>
    )
  }
}

export default FaqItem
